import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class TextOval extends MainComponent {

    static propTypes = {
        text: PropTypes.string,
        search: PropTypes.string,
        select: PropTypes.bool,
        onClick: PropTypes.func,
    };
    static defaultProps = {
        text: "",
        search: "",
        onClick: null,
        select: false,
    };
    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    highlight(text, search) {
        const escapedText = this.escapeRegExp(search);
        const regex = new RegExp(`^(${escapedText})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, index) => {
            if (part.match(regex)) {
                return <span key={index} className="highlighted">{part}</span>;
            }
            return part;
        });
    }

    onClick() {
        if (this.props.onClick?.apply)
            this.props.onClick();
    }

    onMouseDown(e) {
        this._helper.stopEvent(e);
    }

    render() {
        const { text, search, active, select } = this.props;
        const cl = active ? "active" : "";
        const clsel = select ? "select" : "";

        return (
            <div
                className={`ovalText text p2 hand ${cl} ${clsel}`}
                onClick={this.onClick.bind(this)}
                onMouseDown={this.onMouseDown.bind(this)}>
                {search ?
                    <div className={`highlightText ${cl}`}>
                        {this.highlight(text, search)}
                    </div> :
                    this.tr(text)}
            </div>
        );
    }
}
